<template>
  <div class="content">
    <div v-show="isActiveLoader || isLoading" class="loader">
      <ul>
        <li />
        <li />
        <li />
        <li />
        <li />
        <li />
      </ul>
    </div>
    <slot />
  </div>
</template>

<script>
import isArray from 'lodash/isArray';

export default {
  name: 'Loader',
  props: {
    isLoading: {
      type: Boolean,
      required: false
    },
    watch: {
      type: [String, Array]
    }
  },
  computed: {
    isActiveLoader() {
      const loaders = isArray(this.watch) ? this.watch : [this.watch];
      return loaders.filter(loader => !!this.$store.getters.activeLoaders(loader)).length;
    }
  }
};
</script>
